import { render } from "./ProtectionReportTableElement.vue?vue&type=template&id=236a15ce"
import script from "./ProtectionReportTableElement.vue?vue&type=script&lang=js"
export * from "./ProtectionReportTableElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__